import React, { useState } from 'react';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore, doc, setDoc, getDoc } from 'firebase/firestore';
import PhoneModal from './PhoneModal';
import './GoogleSignIn.css';

const GoogleSignIn = ({ onAuthSuccess, onClose }) => {
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [newUser, setNewUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');
    
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      // Forzar mostrar el selector de cuentas siempre
      provider.setCustomParameters({ prompt: 'select_account' });
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const db = getFirestore();

      // Verificar si el usuario ya existe en Firestore
      const userRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        // Usuario existente, iniciar sesión directamente
        onAuthSuccess();
      } else {
        // Usuario nuevo, requiere completar teléfono
        setNewUser({
          uid: user.uid,
          name: user.displayName?.split(' ')[0] || '',
          apellido: user.displayName?.split(' ').slice(1).join(' ') || '',
          email: user.email,
          photoURL: user.photoURL,
        });
        setShowPhoneModal(true);
      }
    } catch (err) {
      console.error('Error en Google Sign-In:', err);
      if (err.code === 'auth/popup-closed-by-user') {
        setError('Se cerró el popup de autenticación.');
      } else if (err.code === 'auth/network-request-failed') {
        setError('Error de conexión. Intenta nuevamente.');
      } else {
        setError('Error al iniciar sesión con Google. Intenta nuevamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneSubmit = async (telefono) => {
    try {
      setLoading(true);
      const db = getFirestore();

      // Crear documento del usuario en Firestore con el teléfono
      await setDoc(doc(db, 'users', newUser.uid), {
        uid: newUser.uid,
        name: newUser.name,
        apellido: newUser.apellido,
        email: newUser.email,
        telefono: telefono,
        photoURL: newUser.photoURL,
        recibirNotificaciones: false,
        role: 'cliente',
        createdAt: new Date().toISOString(),
      });

      setShowPhoneModal(false);
      setNewUser(null);
      onAuthSuccess();
    } catch (err) {
      console.error('Error al guardar datos del usuario:', err);
      setError('Error al completar el registro. Intenta nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  if (showPhoneModal && newUser) {
    return (
      <PhoneModal
        user={newUser}
        onSubmit={handlePhoneSubmit}
        onCancel={() => {
          setShowPhoneModal(false);
          setNewUser(null);          setError('');        }}
        loading={loading}
      />
    );
  }

  return (
    <div className="google-signin-container">
      {error && <p className="error-message">{error}</p>}
      <button
        onClick={handleGoogleSignIn}
        disabled={loading}
        className="google-signin-button"
      >
        <svg className="google-icon" viewBox="0 0 24 24">
          <path
            fill="#EA4335"
            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          />
          <path
            fill="#34A853"
            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          />
          <path
            fill="#FBBC05"
            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          />
          <path
            fill="#4285F4"
            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          />
        </svg>
        {loading ? 'Conectando...' : 'Continuar con Google'}
      </button>
    </div>
  );
};

export default GoogleSignIn;
